
import './styles/quasar.scss'
import iconSet from 'quasar/icon-set/material-icons-sharp.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons-round/material-icons-round.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import '@quasar/extras/material-icons-sharp/material-icons-sharp.css'

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
  },
  iconSet: iconSet
}